export const IMPLEMENTS_TYPES = [
    {
        value: 0,
        text: "Desconhecido"
    },
    {
        value: 1,
        text: "Adubadora"
    },
    {
        value: 2,
        text: "Arado de Disco"
    },
    {
        value: 3,
        text: "Barra de Pulverização"
    },
    {
        value: 4,
        text: "Cabeçote"
    },
    {
        value: 5,
        text: "Carreta de Grãos"
    },
    {
        value: 6,
        text: "Colhedora"
    },
    {
        value: 7,
        text: "Cortador Rotativo"
    },
    {
        value: 8,
        text: "Cultivador de campo"
    },
    {
        value: 9,
        text: "Cultivador de Linhas"
    },
    {
        value: 10,
        text: "Enfardadeira Quadrada"
    },
    {
        value: 11,
        text: "Enfardadeira Redonda "
    },
    {
        value: 12,
        text: "Enleirador"
    },
    {
        value: 13,
        text: "Enleirador de Rodas"
    },
    {
        value: 14,
        text: "Enxada rotativa"
    },
    {
        value: 15,
        text: "Escarificador"
    },
    {
        value: 16,
        text: "Forrageira"
    },
    {
        value: 17,
        text: "Rolo Faca"
    },
    {
        value: 18,
        text: "Grade niveladora"
    },
    {
        value: 19,
        text: "Grade Pesada"
    },
    {
        value: 20,
        text: "Implemento de Aplicação Especial"
    },
    {
        value: 21,
        text: "Implemento de Feno e Forragem"
    },
    {
        value: 22,
        text: "Implemento de Preparo de Solo"
    },
    {
        value: 23,
        text: "Motoniveladora"
    },
    {
        value: 24,
        text: "Plantadora"
    },
    {
        value: 25,
        text: "Plataforma"
    },
    {
        value: 26,
        text: "Plataforma para Algodão"
    },
    {
        value: 27,
        text: "Plataforma para Cana-de-açúcar"
    },
    {
        value: 28,
        text: "Plataforma para Milho"
    },
    {
        value: 29,
        text: "Pulverizador"
    },
    {
        value: 30,
        text: "Pulverizador Rebocado"
    },
    {
        value: 31,
        text: "Reboque"
    },
    {
        value: 32,
        text: "Roçadeira"
    },
    {
        value: 33,
        text: "Segadeira"
    },
    {
        value: 34,
        text: "Semeadora"
    },
    {
        value: 35,
        text: "Semeadora Pneumática"
    },
    {
        value: 36,
        text: "Sopradora"
    },
    {
        value: 37,
        text: "Subsolador"
    },
    {
        value: 38,
        text: "Triturador"
    },
    {
        value: 39,
        text: "Unidades de Colheita Rotativas"
    }
]

export const IMPLEMENT_POSITIONS = [
    {
        name: 'Frontal',
        code: 'front',
        crpMultiplier: -10,
        erpMultiplier: 10
    },
    {
        name: 'Traseiro',
        code: 'back',
        crpMultiplier: 10,
        erpMultiplier: -10
    }
]

export const CONNECTOR_TYPES = [
    {
        "id": 0,
        "name": "Desconhecido"
    },
    {
        "id": 1,
        "name": "Barra de Tração"
    },
    {
        "id": 2,
        "name": "Engate de Três Pontos Semimontados"
    },
    {
        "id": 3,
        "name": "Engate de Três Pontos Montado"
    },
    {
        "id": 4,
        "name": "Gancho"
    },
    {
        "id": 5,
        "name": "Forquilha"
    },
    {
        "id": 6,
        "name": "Piton"
    },
    {
        "id": 7,
        "name": "Engate CUNA"
    },
    {
        "id": 8,
        "name": "Esfera"
    },
    {
        "id": 9,
        "name": "Montado no Chassi"
    },
    {
        "id": 10,
        "name": "Engate de Vagão"
    }
]

export const CULTURE_PRACTICE_LIST = [
    {
        value: 0,
        text: "Desconhecido"
    },
    {
        value: 1,
        text: "Fertilização"
    },
    {
        value: 2,
        text: "Semeadura e Plantio"
    },
    {
        value: 3,
        text: "Pulverização"
    },
    {
        value: 4,
        text: "Lavoura"
    },
    {
        value: 5,
        text: "Enfardamento (Prensagem)"
    },
    {
        value: 6,
        text: "Corte"
    },
    {
        value: 7,
        text: "Embalagem"
    },
    {
        value: 8,
        text: "Colheita"
    },
    {
        value: 9,
        text: "Colheita de Forragem"
    },
    {
        value: 10,
        text: "Transporte"
    },
    {
        value: 11,
        text: "Enfardamento"
    },
    {
        value: 12,
        text: "Aplicação de chorume/esterco"
    },
    {
        value: 13,
        text: "Carroça autocarregável"
    },
    {
        value: 14,
        text: "Tedding"
    },
    {
        value: 15,
        text: "Medição"
    },
    {
        value: 16,
        text: "Irrigação"
    },
    {
        value: 17,
        text: "Alimentação/mistura"
    },
    {
        value: 18,
        text: "Adubação"
    },
    {
        value: 19,
        text: "Reservado"
    }
]

export const MONITORING_SYSTEMS = [
    {
        id: 0,
        name: 'Não possui',
        value: null
    },
    {
        id: 1,
        name: 'ISOBUS',
        value: 'ISOBUS'
    },
    {
        id: 2,
        name: 'Auteq - MPA 2500',
        value: 'MPA2500'
    },
    {
        id: 3,
        name: 'Precision Planting',
        value: 'PRECISION_PLANTING'
    }
]
